import { Component, OnInit, NgZone } from '@angular/core';
import { Util } from '../../shared-service/util.service';
import { BaseService } from '../../shared-service/base.service';
import { SharingPanelService } from '../../shared-service/sharing-panel-service';

declare var Tree: any;

@Component({
	selector: 'app-visibility-filter',
	templateUrl: './visibility-filter.component.html',
	styleUrls: ['./visibility-filter.component.css']
})
export class VisibilityFilterComponent implements OnInit {

	loader: boolean = true;
	constructor(private ngZone: NgZone, private util: Util, public bs: BaseService, private sps: SharingPanelService) { }

	ngOnInit() {
		console.log('ngOnInit VisibilityFilterComponent');
		this.loadTreeView();
	}

	loadTreeView() {
		const script = [
        	'assets/js/tree.js'
        ];
        this.util.getScripts(script).then((success) => {
        	console.log('Script loaded successfully');
        	this.getTreeData();
        }, () => {
        	this.loadTreeView();
        });
	}

	getTreeData() {
		const params: Object = { 'UserID': this.bs.getUserAttr('UserId'), 'CorporateID': this.bs.getUserAttr('CorporateId') };
		this.sps.GetShareTreeJson(params, "****").then((data:any) => {
			let treeJson=JSON.parse(data["TreeJson"]);
			this.sps.treeData['data'] = treeJson[0];
			this.sps.treeData['rootId'] = 'rootTree';
			this.ngZone.runOutsideAngular(()=>{
				let treeRoot = new Tree('rootTree', false, treeJson[0]);
				treeRoot.init();
				this.loader = false;
			});
		}, (err) => {
			console.log(err);
			this.loader = false;
		});
	}

	updateView(ev: Event) {
		this.sps.changeDetected.next(ev['timeStamp'].toString());
	}

}